import { registerBlockType } from '@wordpress/blocks'
import config, { BlockAttributes } from './block.json'
import '../slider/swiper'
import IconCardSave from './IconCardSave'
import IconCardEditor from './IconCardEditor'

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  edit: IconCardEditor,
  save: IconCardSave
})
